import React, { memo, useContext, useEffect, useState } from "react";


import { logApi, MainSumApi } from "../../../../../../../api/Api";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme } from '@mui/material';


import { InverterContext } from '../../../../../../../context/InverterContext';
import { AppThemeContext } from '../../../../../../../context/AppThemeContext';
import backgroundImage from '../../../../../../../assets/img/bg/chart2.png';
import { AuthenticationContext } from '../../../../../../../context/AuthenticationContext'

import SettingsIcon from '@mui/icons-material/Settings';

import AutorenewIcon from '@mui/icons-material/Autorenew';

import SolarSvg2 from "../../../../../../../assets/svg/lastSolarSvg2";

import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../../utils'

import AppModal from "../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";
import Load3Svg from "../../../../../../../assets/svg/Load3Svg";
import Load1Svg from "../../../../../../../assets/svg/Load1Svg";
import SolarGrid1 from "../../../../../../../assets/svg/SolarGrid1";




function SingleSolarGrid() {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)

    const { PrimaryColor } = useContext(AppThemeContext);

    const { spacing, palette, shape: { borderRadius } } = useTheme();
    const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

    const [logData, setLogData] = useState([]);
    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const [credentials, setCredentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID"),
        LOC_CODE: sessionStorage.getItem("LCODE"),
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: sessionStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("KEY") || "xyz",
        LCODE: sessionStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });



    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    // useEffect(() => {
    //     fetchLogData();
    // }, [credentials]); // Fetch new data when credentials change


    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };

    // useEffect(() => {
    //     fetchData();
    // }, [sumCredentials]); // Fetch new data when credentials change

    // console.log("LoggedInUserInfo",LoggedInUserInfo)

    useEffect(() => {
        // Fetch data immediately on mount
        fetchLogData();
        fetchData();

        // Set interval to fetch data every 30 seconds
        const interval = setInterval(() => {
            fetchLogData();
            fetchData();
        }, 60000); // 30 seconds in milliseconds

        // Cleanup interval on unmount
        return () => clearInterval(interval);
    }, [credentials, sumCredentials]); // Dependencies to trigger re-setup if these values change



    const blinkingAnimationDateTime = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
    }
    const blinkingAnimationBatteryStatusCharging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'green'
    }
    const blinkingAnimationBatteryStatusDischarging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'red'
    }

    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '1rem'
        }
    }

    return (

        <>


            <Grid container style={{ padding: "0", margin: "0" }}>
                {logData.map((log, index) => (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)}>
                        <Container sx={{ maxWidth: '100%', height: 'auto', position: 'relative' }}>





                            <SolarGrid1 svgColor={palette.primary.main} />



                            <Typography variant='body2' sx={{ position: 'absolute', top: '25%', left: '27%', color: "red" }} className="blink">
                                {log.IRR !== undefined ? log.IRR : "N/A"} W/m<sup>2</sup>
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    position: "absolute",
                                    top: "61%",
                                    left: "26%",
                                    color: "red", // Apply red color directly via sx
                                }}
                                className="blink" // Add the blink class for animation
                            >
                                {log.SOLAR !== undefined ? log.SOLAR : "N/A"} Kw
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    position: "absolute",
                                    top: "2%",
                                    right: "40%",
                                    color:
                                        log.PLANT_STATUS?.toLowerCase() === "plant online"
                                            ? "green"
                                            : log.PLANT_STATUS?.toLowerCase() === "plant offline"
                                                ? "red"
                                                : "inherit", // fallback if status is something else or undefined
                                }}
                            >
                                <span style={{ fontSize: "1.3rem" }}>{log.PLANT_STATUS !== undefined ? log.PLANT_STATUS : "N/A"}</span>
                            </Typography>


                            {/* <Typography variant='body2' sx={{ position: 'absolute', bottom: '7%', left: '26%', color: "red" }} className="blink" >
                                {log.GenSet !== undefined ? log.GenSet : "N/A"} Kw
                            </Typography> */}

                            {/* <Typography variant='body2' sx={{ position: 'absolute', top: '10%', right: '25%' }}>
                            {HYBRD_DATA_INFO?.INPUT_AC_ACTIVE_POWER} Kw Imp
                        </Typography>

                        <Typography variant='body2' sx={{ position: 'absolute', top: '20%', right: '25%' }}>
                            {HYBRD_DATA_INFO?.['GRID POWER EXPORT']} Kw Exp
                        </Typography> */}

                            <Typography variant='body2' sx={{ position: 'absolute', top: '25%', right: '30%', color: "red" }} className="blink" >
                                {log.GRID !== undefined ? log.GRID : "N/A"} kW
                            </Typography>

                            <Typography variant='body2' sx={{ position: 'absolute', top: '61%', right: '25%', color: "red" }} className="blink" >
                                {log.FRQ !== undefined ? log.FRQ : "N/A"} &nbsp;
                                Hz
                            </Typography>

                            {Number(log.Grid_PF) !== 0 && (
                                <Typography
                                    variant="body2"
                                    sx={{ position: 'absolute', top: '15%', right: '11%' }}
                                >
                                    <span>PF&nbsp;</span>
                                    <span
                                        className="blink"
                                        style={{ fontSize: '0.8rem', color: 'red' }}
                                    >
                                        {log.Grid_PF !== undefined ? log.Grid_PF : 'N/A'}
                                    </span>
                                </Typography>
                            )}

                            <Typography variant='body2' sx={{ position: 'absolute', top: '68%', right: '24%', color: "red" }} className="blink" >
                                {log.MAINS_AVG_VOLT !== undefined ? log.MAINS_AVG_VOLT : "N/A"} &nbsp;
                               
                            </Typography>

                            {/* <Typography variant='h6' textAlign={'center'} color={'primary.main'} sx={{ position: 'absolute', top: '44%', right: '52%' }}>
                            {HYBRD_DATA_INFO?.PSTS}
                        </Typography> */}

                            {/* <Typography variant='body2' sx={{ position: 'absolute', bottom: '9%', right: '30%', color: "red" }} className="blink" >
                                {log.TOTAL_LOAD !== undefined ? log.TOTAL_LOAD : "N/A"} Kw
                            </Typography> */}

                            {/* <Box sx={{ position: 'absolute', top: '10%', left: '38%' }}>
                            <Typography textAlign={'center'} variant='body2'>
                                {HYBRD_DATA_INFO?.DATE_TIME}
                            </Typography>
                            <Typography textAlign={'center'} variant='body2'>
                                {HYBRD_DATA_INFO?.STATUS}
                            </Typography>
                        </Box> */}

                            {/* <Box sx={{ position: 'absolute', bottom: '-4%', left: '36%' }}>
                            <Typography variant='body2' textAlign={'center'}>ALARM</Typography>
                            <Typography variant='body2' style={blinkingAnimationDateTime}>
                                {HYBRD_DATA_INFO?.ALARM}
                            </Typography>
                        </Box> */}
                        </Container>
                    </Grid>
                ))}


            </Grid>



        </>
    );
}


export default memo(SingleSolarGrid)